module.exports = __webpack_public_path__ + "media/images/PIE-PAGINA-1fc099786a2bfc43572a27b3ae87baba.png";